import * as PNotify from '@pnotify/core';
import * as PNotifyPaginate from '@pnotify/paginate';
import * as PNotifyMobile from '@pnotify/mobile';
PNotify.defaultModules.set(PNotifyMobile, {});

window.PNotify = PNotify;
console.ext = {};
console.pop = {};
console.inline = {};

window.newPnotify = function (optDefault) {
    return new PNotify(optDefault);
};
console.ext.string = function (opt, optOR) {
    opt.text = `${optOR}`;
    return opt;
};
console.ext.number = function (opt, optOR) {
    opt.text = `${optOR}`;
    return opt;
};
console.ext.object = function (opt, optOR) {
    if (optOR.text) {
        opt.text = `${optOR.text}`;
    }
    return $.extend(opt, optOR);
};

window.stackPaginate = new PNotify.Stack({
    dir1: 'down',
    dir2: 'left',
    firstpos1: 25,
    firstpos2: 25,
    modal: false,
});

console.pop.error = function (e) {
    var optDefault = {
        title: 'Error',
        text: 'Error',
        textTrusted: true,
        hide: false,
        stack: window.stackPaginate,
        destroy: true,
        modules: new Map([...PNotify.defaultModules, [PNotifyPaginate, {}]]),
    };
    if (e) {
        optDefault = console.ext[typeof e](optDefault, e);
    }

    var usePNotify = parent.$('#frameBody').get(0)
        ? parent.PNotify.error(optDefault)
        : PNotify.error(optDefault);

    return usePNotify;
};

console.pop.info = function (e) {
    console.log('e: ', e);
    var optDefault = {
        title: 'Info',
        text: 'info',
        textTrusted: true,
        hide: false,
    };
    if (e) {
        optDefault = console.ext[typeof e](optDefault, e);
    }

    var usePNotify = parent.$('#frameBody').get(0)
        ? parent.PNotify.info(optDefault)
        : PNotify.info(optDefault);

    return usePNotify;
};
console.pop.success = function (e) {
    var optDefault = {
        title: 'Success',
        text: 'success',
        textTrusted: true,
        hide: true,
    };
    if (e) {
        optDefault = console.ext[typeof e](optDefault, e);
    }

    var usePNotify = parent.$('#frameBody').get(0)
        ? parent.PNotify.success(optDefault)
        : PNotify.success(optDefault);

    return usePNotify;
};

console.pop.notice = function (e) {
    var optDefault = {
        title: 'Notice',
        text: 'Notice',
        textTrusted: true,
        hide: true,
    };

    if (e) {
        optDefault = console.ext[typeof e](optDefault, e);
    }

    return parent.$('#frameBody').get(0)
        ? parent.PNotify.notice(optDefault)
        : PNotify.notice(optDefault);
};

console.pop.warning = function (e) {
    var optDefault = {
        title: 'Warning',
        text: e,
        textTrusted: true,
        type: 'error',
        buttons: {
            sticker: false,
        },
    };
    if (e) {
        optDefault = console.ext[typeof e](optDefault, e);
    }

    return parent.$('#frameBody').get(0)
        ? parent.PNotify.alert(optDefault)
        : PNotify.alert(optDefault);
};
console.pop.none = function (e) {
    //alert('s')
    var optDefault = {
        title: 'Notice',
        text: 'Notice',
        textTrusted: true,
        type: '',
        hide: true,
    };
    if (e) {
        optDefault = console.ext[typeof e](optDefault, e);
    }

    return parent.$('#frameBody').get(0)
        ? parent.PNotify.alert(optDefault)
        : PNotify.alert(optDefault);
};

console.pop['null'] = function (e) {
    //alert('s')
    var optDefault = {
        title: 'Notice',
        text: 'Notice',
        textTrusted: true,
        type: '',
        hide: true,
    };
    if (e) {
        optDefault = console.ext[typeof e](optDefault, e);
    }
    return parent.$('#frameBody').get(0)
        ? parent.PNotify.alert(optDefault)
        : PNotify.alert(optDefault);
};

console.inline.view = function (obj) {
    var id = $.now();
    obj.id = id;

    var str = $(
        `<div id="${id}" class="uk-alert uk-alert-${obj.type}">${obj.text}</a></div>`
    );
    if (obj.close) {
        str.append(
            $(
                '<a type="button" class="uk-alert-close uk-close" data-dismiss="alert" aria-label="Close" onclick="$(this).parent().remove();">'
            )
        );
    }

    if (obj.delay) {
        setTimeout(function () {
            $('#' + obj.id).remove();
        }, obj.delay);
    }
    return str;
};
console.inline.success = function (Obj) {
    var deObj = {
        target: $('body'),
        text: 'success',
        type: 'success',
        title: 'success',
        replace: 'html',
        close: true,
    };
    deObj = console.ext[typeof Obj](deObj, Obj);
    deObj.target[deObj.replace](console.inline.view(deObj));
};

console.inline.notice = function (Obj) {
    var deObj = {
        target: $('body'),
        text: 'notice',
        type: 'notice',
        title: 'notice',
        replace: 'html',
        close: true,
    };
    deObj = console.ext[typeof Obj](deObj, Obj);
    deObj.target[deObj.replace](console.inline.view(deObj));
};

console.inline.warning = function (Obj) {
    var deObj = {
        target: $('body'),
        text: 'warning',
        type: 'warning',
        title: 'warning',
        replace: 'html',
        close: true,
    };
    deObj = console.ext[typeof Obj](deObj, Obj);
    deObj.target[deObj.replace](console.inline.view(deObj));
};
console.inline.error = function (Obj) {
    var deObj = {
        target: $('body'),
        text: 'error',
        type: 'danger',
        title: 'error',
        replace: 'html',
        close: true,
    };
    deObj = console.ext[typeof Obj](deObj, Obj);
    deObj.target[deObj.replace](console.inline.view(deObj));
};
console.inline.info = function (Obj) {
    var deObj = {
        target: $('body'),
        text: 'info',
        type: 'primary',
        title: 'info',
        replace: 'html',
        close: true,
    };
    deObj = console.ext[typeof Obj](deObj, Obj);
    deObj.target[deObj.replace](console.inline.view(deObj));
};
